module.exports = __webpack_public_path__ + "static/media/survey_wording.c31293f3.png";